import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.507 22c-.26 0-.51-.1-.71-.29l-9.004-9a.996.996 0 0 1 0-1.41l9.004-9.01a.997.997 0 1 1 1.41 1.41L7.914 12l8.293 8.29a.996.996 0 0 1-.71 1.7l.01.01Z"
    />
  </svg>
);
export default SvgChevronLeft;
